import React from "react";
import { Dimensions, StyleSheet } from "react-native";
import LottieView from "lottie-react-native";
import { isWebDesktop } from "@microdoing/shared/utils/deviceDetectors";

const { width } = Dimensions.get("window");

const styles = {
  animationStyle: {
    height: isWebDesktop ? 250 : width * 0.5,
    width: isWebDesktop ? 250 : width * 0.5,
  },
};

export default class BasicExample extends React.Component {
  componentDidMount() {
    this?.animation?.play(0, 32);
  }

  render() {
    return (
      <LottieView
        ref={animation => {
          this.animation = animation;
        }}
        loop={true}
        style={styles.animationStyle}
        source={require("../../../assets/lottie/team.json")}
      />
    );
  }
}
